export const trash = 'M155 39V21h-54v18H47v27h162V39zm41 198V82H60v155'
